export default __webpack_public_path__ + "static/media/val1.d15a6aa1.png";